// https://www.stimulus-components.com/docs/stimulus-reveal-controller/
import { Controller } from "@hotwired/stimulus"

const GRID_EXPANDED_CLASS = "grid-template-rows-[1fr]"
const GRID_COLLAPSED_CLASS = "grid-template-rows-[0fr]"
const GRID_BASE_CLASSES = ["grid", "transition-all", "duration-300", "ease-in-out"]
const GRID_CONTENT_CLASSES = ["overflow-hidden", "min-h-0"]

export default class extends Controller {
  static targets = ["item", "toggleIcon", "resetWhenToggle", "gridWrapper"]
  static values = { mode: { type: String, default: "class" } }
  static classes = ["hidden"]

  connect() {
    this.class = this.hasHiddenClass ? this.hiddenClass : "hidden";

    if (this.hasModeValue && this.modeValue === "grid") {
      this.applyGridModeClasses()
    }
  }  
  
  toggle() {
    if (this.hasToggleIconTarget) {
      this.toggleIconTargets.forEach(item => {
        item.classList.toggle(this.class);
      });
    }

    if (this.hasModeValue && this.modeValue === "grid") {
      this.toggleGrid();
      return
    }

    this.itemTargets.forEach(item => {
      if (this.resetWhenToggleTargets) {
        this.resetItemsValue(this.resetWhenToggleTargets)
      }

      item.classList.toggle(this.class);
    });
  }

  show() {
    if (this.hasModeValue && this.modeValue === "grid") {
      this.expandGrid();
      return
    }

    this.itemTargets.forEach(item => {
      item.classList.remove(this.class);
    });
  }

  hide() {
    if (this.hasModeValue && this.modeValue === "grid") {
      this.collapseGrid();
      return
    }

    this.itemTargets.forEach(item => {
      item.classList.add(this.class);
    });
  }

  toggleGrid() {
    if (!this.hasGridWrapperTarget) return
    const wrapper = this.gridWrapperTarget
    if (wrapper.classList.contains(GRID_EXPANDED_CLASS)) {
      wrapper.classList.remove(GRID_EXPANDED_CLASS)
      wrapper.classList.add(GRID_COLLAPSED_CLASS)
    } else {
      wrapper.classList.remove(GRID_COLLAPSED_CLASS)
      wrapper.classList.add(GRID_EXPANDED_CLASS)
    }
  }

  expandGrid() {
    if (!this.hasGridWrapperTarget) return
    this.gridWrapperTarget.classList.remove(GRID_COLLAPSED_CLASS)
    this.gridWrapperTarget.classList.add(GRID_EXPANDED_CLASS)
  }

  collapseGrid() {
    if (!this.hasGridWrapperTarget) return
    this.gridWrapperTarget.classList.remove(GRID_EXPANDED_CLASS)
    this.gridWrapperTarget.classList.add(GRID_COLLAPSED_CLASS)
  }

  applyGridModeClasses() {
    if (!this.hasGridWrapperTarget) return

    this.gridWrapperTarget.classList.add(...GRID_BASE_CLASSES)
    this.gridWrapperTarget.classList.add(GRID_COLLAPSED_CLASS)

    if(this.gridWrapperTarget.classList.contains('hidden')) {
      this.gridWrapperTarget.classList.remove('hidden')
    }

    const content = this.gridWrapperTarget.firstElementChild
    if (content) {
      content.classList.add(...GRID_CONTENT_CLASSES)
    }
  }

  resetItemsValue(items) {
    items.forEach(item => {
      if (item.tagName == "INPUT") {
        item.value = '';
      } 
      else {
        item.innerText = '';
      }
    });
  }
}
